module.exports = __webpack_public_path__ + "img/Organization.ff73991a.png";